export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals-portals/modal-proppit.store.ts"